export enum DictChainIntegrationType {
	OnlyContactDetails = 1,
	ContactDetailsAndPriceList = 2,
	ContactDetailsAndPriceListAndAvailability = 3,
	FullAdminPanelWithCommonUserPanel = 4,
	FullAdminPanelWithoutCommonUserPanel = 5,
	AdminPanelLight = 6,
}

export enum DictContractIntegrationType {
	Disabled = 1,
	OnlyOtherType,
	Full,
}

export enum AlertFilter {
	Opened = 1,
	All,
	Rented,
	PendingVerification,
	Available,
	OutOfUse,
	Gates,
	Unpaid,
	Padlock,
}

export enum OpenStatus {
	Closed = 1,
	Open,
	OpenTooLong,
	Undefined,
	ReadyToOpen,
}

export enum DictPadLockMode {
	Standard = 0,
	Permanent = 1,
}

export enum UserRole {
	ChainAdmin = 'LocationChainAdmin',
	LocationAdmin = 'LocationAdmin',
}

export enum AppLanguage {
	English = 'en',
	Polish = 'pl',
}

export enum GateType {
	Default = 1,
	Alarm,
}

export enum AlarmType {
	Loxone = 1,
	Satel = 2,
}

export enum AlarmZoneMode {
	ExtendDisarm = 1,
	FullControl = 2,
}

export enum DictLockerStatus {
	Available = 1,
	Rented = 2,
	Reserved = 3,
	PendingVerification = 4,
	Resigned = 5,
	Reservation = 6,
	OutOfUse = 7,
}

export enum DictOrderItemStatus {
	Active = 1,
	Resigned = 2,
	Finished = 3,
	HistoricallyPotential = 4,
}
export enum DictOrderStatus {
	Created = 1,
	Pending = 2,
	Successful = 3,
	Failed = 4,
	Finished = 5,
	ExtendableFinished = 6,
	Reservation = 7,
	Potential = 8,
}

export enum DictTenantCompanyType {
	Private = 1,
	SimpleCompany = 2,
	PLJDG = 3,
	PLSpZoo = 4,
	PLSpJ = 5,
	PLSpC = 6,
}

export enum DictLockerEventType {
	Undefined = 0,
	PinAccepted = 1,
	PinRejected = 2,
	PinExpired = 3,
	Opened = 4,
	ForceOpened = 5,
	Closed = 6,
	LockerLocked = 7,
	ReadyToOpen = 8,
	NoCommunication = 9,
	Timeout = 10,
	LockerCommandSent = 11,
	LockerArmed = 98,
	LockerDisarmed = 99,
	MSpaceLockOpened = 100,
	MSpaceLockNotOpened = 101,
	TTLockOpened = 102,
	TTLockNotOpened = 103,
}

export enum DictGateEventType {
	Undefined = 0,
	PinAccepted = 1,
	PinRejected = 2,
	PinExpired = 3,
	Opened = 4,
	ForceOpened = 5,
	Closed = 6,
	LockerLocked = 7,
	ReadyToOpen = 8,
	NoCommunication = 9,
	Timeout = 10,
	GateCommandSent = 11,
	LicensePlateAccepted = 12,
	LicensePlateRejected = 13,
	MSpaceLockOpened = 100,
	MSpaceLockNotOpened = 101,
	TTLockOpened = 102,
	TTLockNotOpened = 103,
}

export enum DictPriceCalculationConfig {
	BruttoFirst = 1,
	NettoFirst = 2,
}

export enum DictUserPanelDisplayPrice {
	Gross = 1,
	Net = 2,
}
